// Web no-op for push registration. FCM on the web needs a service worker and a
// VAPID key — deferred. Native is index.ts (@react-native-firebase/messaging).

export const isAvailable = (): boolean => false;
export const requestPermissionAndToken = async (): Promise<string | null> => null;
export const onTokenRefresh = (): (() => void) => () => {};
export const saveFcmToken = async (): Promise<void> => {};
export const saveAlerts = async (): Promise<void> => {};
export const registerForPush = async (): Promise<string | null> => null;

export default {
  isAvailable,
  requestPermissionAndToken,
  onTokenRefresh,
  saveFcmToken,
  saveAlerts,
  registerForPush,
};
